export default __webpack_public_path__ + "static/media/agreementExpress.bdbfc557.svg";